import { defineMessages } from 'react-intl'

const messages = {
  pickupIn: {
    id: 'app.components.countdown-pickup-timer.pickup-in',
    defaultMessage: 'Pickup {count}',
  },
}

export default defineMessages(messages)
